<template>
	<div class="pageHome" :style="height">
		<img :src="headimgurl" style="width: 8.75rem;height: 8.75rem;margin-top: -250px;" />
		<div style="margin-bottom: 30px;color: #ffdd93;">欢迎! {{nickname}}</div>
		<input v-if="isPhone" style="width: 50%;height: 40px;" v-model="PhoneNumber" placeholder="中奖后联系电话" @keyup="handleInput" />
		<div @click="clickJump()" style="background-color:  rgb(231,40,35);color: #FFFFFF;width: 50%;height: 40px;border-radius: 5px;margin-top: 50px;display: flex;justify-content: center;align-items: center;">
			签到入场
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import request from '../../common/request.js'
	let appid = 'wxf72b4de61dcf0cde';
	let secret = '7e97890b3931880d4e960a2ba39e5b25'
	let windowHeight = document.documentElement.clientHeight
	let that;

	export default {
		name: 'SignIn',
		data() {
			return {
				isPhone: false,
				PhoneNumber: '',
				headimgurl: '',
				nickname: '',
				openid: '',
				height: 'height:' + windowHeight + 'px',
			}
		},
		created() {
			that = this
			this.getCode();
		},
		methods: {
			getCode() { // 非静默授权，第一次有弹框
				this.code = ''
				let local = window.location.href // 获取页面url
				this.code = this.getUrlCode().code // 截取code
				// console.log('code', this.code);
				if (!this.code) { // 如果没有code，则去请求
					window.location.href =
						`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
					// console.log(						`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`);
				} else {
					// 你自己的业务逻辑
					let data = {
						code: this.code
					}
					let requests = request.getQueryData(data || {})
					axios.post('https://test.lfwellness.cn/api_erp/Meting/get_userinfo_by_code',
						requests).then(function(data) {
						if (data.data.ResultCode == 200) {
							let item = data.data.Data
							that.headimgurl = item.headimgurl
							that.nickname = item.nickname
							that.openid = item.openid
							that.clickJump();
						} else {
							alert(data.data.Message)
						}
					})
				}
			},
			getUrlCode() { // 截取url中的code方法
				var url = location.search
				this.winUrl = url
				var theRequest = new Object()
				if (url.indexOf("?") != -1) {
					var str = url.substr(1)
					var strs = str.split("&")
					for (var i = 0; i < strs.length; i++) {
						theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
					}
				}
				return theRequest
			},
			clickJump() {
				let data = {
					u_open_id: that.openid,
					u_nick_name: that.nickname,
					u_url: that.headimgurl
				}
				if (that.isPhone) {
					data.u_tel = that.PhoneNumber
					if (that.PhoneNumber.length != 11) {
						alert('请输入完整手机号')
						return
					}
				}
				let requests = request.getQueryData(data || {})
				axios.post('https://test.lfwellness.cn/api_erp/Meting/sign_in_2021',
					requests).then(function(data) {
					if (data.data.ResultCode == 200 || data.data.ResultCode == 101) {
						//签到成功
						let routeUrl = that.$router.resolve({
							path: "/meetingShake",
							query: {
								openid: that.openid
							}
						});
						window.open(routeUrl.href, '_self');
					} else if (data.data.ResultCode == 109) {
						that.isPhone = true
					} else {
						alert(data.data.Message)
					}
				})
			},
			handleInput(e) {
				this.PhoneNumber = this.PhoneNumber.replace(/[^\d]/g, '')
			}
		}
	}
</script>

<style>
	.pageHome {
		/* position: absolute; */
		margin: 0 auto;
		width: 100%;
		max-width: 33.75rem;
		background: url(/images/shakeImg/QianBac.jpg) no-repeat;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
